/**
 * Validates if a data is already in the cart
 * If the domain is valid, it returns the cleaned domain
 * @param {Item} dataCart products inCart
 * @returns {Array} CartProducts whithout the dataSought if it was found
 */

const validateAlreadyExistInCart = (dataCart, dataSought) => {
  dataSought = dataSought.trim();

  // Validate if the data already exists in the cart specificly for domain
  const domainExists = dataCart.some(product =>
    product.product.domain_section[0].dominio_principal === dataSought
  );

  return domainExists;
};

export default validateAlreadyExistInCart;